import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
import { useNavigate } from 'react-router-dom';
let report_add, report_activity_log, report_view;
function ReportsAside() {
    const navigate = useNavigate();
    const intl = useIntl();
    report_add = permissionCheck('report-create')
    report_view = permissionCheck('report-view')
    report_activity_log = permissionCheck('report-activity-log')
    return (
        <>
            <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reports</span>
                </div>
            </div>
            <AsideMenuItem
                to='/hr/reports/attendance'
                title='Attendance Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
            <AsideMenuItem
                to='/hr/reports/leave'
                title='Leave Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
             <AsideMenuItem
                to='/hr/reports/employee-shift-hours'
                title='Shift Timing Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
            <AsideMenuItem
                to="/hr/reports/employee-leave-balance"
                title='Leave Balance Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
              <AsideMenuItem
                to="/hr/reports/employee-contact-details"
                title='Contact Details Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
            <AsideMenuItem
                to="/hr/reports/employee-details"
                title='Employee Details Report'
                fontIcon='bi-archive'
                icon='chart-pie-4'
            />
        </>
    )
}

export default ReportsAside;
